module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_8011.868ac2f7.png";